function pathToRelativeClipPath(pathString) {
    // Helper functions
    function parseCoordsItem(item) {
        const commandSrc = item.substring(0, 1);
        const command = commandSrc.toLowerCase();
        const isCommandUpperCase = command !== commandSrc;
        const keysList = keysListByCommand[command];
        let coordsList = item
            .substring(1)
            .replace(/,$/, '')
            .split(',')
            .map(item => +item);

        return {
            commandSrc,
            command,
            isCommandUpperCase,
            keysList,
            coordsList
        };
    }

    function normalizePathCoords(coords) {
        let result = coords
            .replace(/([a-z]) /gi, '$1')
            .replace(/([a-z])/gi, ' $1')
            .trim()
            .replace(/(\d{1,})(-)/gi, '$1 $2')
            .replace(/\s00/gi, ' 0 0 ')
            .replace(/z/gi, ' ')
            .replace(/,\s{1,}/gi, ',')
            .replace(/\s{1,},/gi, ',')
            .replace(/\s{1,}/gi, ',');

        while (result.match(/\.\d{1,}\.\d{1,}/gi)) {
            result = result.replace(/(\.\d{1,})(\.\d{1,})/gi, '$1,$2');
        }

        return result;
    }

    function round(num) {
        return Math.round(num * 1000) / 1000;
    }

    const keysListByCommand = {
        'm': ['x', 'y'],
        'l': ['x', 'y'],
        'h': ['x'],
        'v': ['y'],
        'c': ['x', 'y', 'x1', 'y1', 'x2', 'y2'],
        's': ['x', 'y', 'x1', 'y1'],
        'q': ['x', 'y', 'x1', 'y1'],
        't': ['x', 'y', 'x1', 'y1'],
        'a': ['rx', 'ry', 'x-axis-rotation', 'large-arc-flag', 'sweep-flag', 'x', 'y']
    };

    // Create temporary SVG to get path dimensions
    const tempSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    const tempPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    tempPath.setAttribute('d', pathString);
    tempSvg.appendChild(tempPath);
    document.body.appendChild(tempSvg);
    const pathSizes = tempPath.getBBox();
    document.body.removeChild(tempSvg);

    // Transform coordinates
    function transformValuesByKeys(keysList, coordsList, itemCommand) {
        return coordsList.map((item, index) => {
            if (!keysList[index] && itemCommand !== 'a') {
                return index % 2 === 0 ?
                    round(item / pathSizes.width) :
                    round(item / pathSizes.height);
            }

            if (keysList[index].includes('rotation') || keysList[index].includes('flag')) {
                return item;
            }

            if (keysList[index].includes('x')) {
                return round(item / pathSizes.width);
            }

            if (keysList[index].includes('y')) {
                return round(item / pathSizes.height);
            }

            return item;
        });
    }

    // Process the path
    const coordsNormalized = normalizePathCoords(pathString);
    const coordsListSrc = [...coordsNormalized.matchAll(/[a-z][^(a-z)]{1,}/gi)]
        .map(item => item[0]);

    const coordsTransformed = coordsListSrc.map(value => {
        const { commandSrc, command, coordsList, keysList } = parseCoordsItem(value);

        if (keysList) {
            const transformedValsList = transformValuesByKeys(keysList, coordsList, command);
            return `${commandSrc}${transformedValsList.join(',')}`;
        }

        return value;
    });

    return coordsTransformed.join(' ');
}

export { pathToRelativeClipPath };